const PROJECT_DATA = {
    "pdfassistant": {
        heading: "Real-Time PDF Questions Answering Assistant",
        icon: "file-pdf",
        iconType: "fas",
        projectLink: "https://github.com/25abubakar/Real-Time-PDF-Questions-Answering-Assistant",
        repoLink: "https://github.com/25abubakar/Real-Time-PDF-Questions-Answering-Assistant",
        projectDesc: [
            "University final-year project — a web-based tool that lets users upload PDF documents and ask questions about their content in real time.",
            "Built with <strong>React (TypeScript)</strong> on the frontend, <strong>Flask (Python)</strong> on the backend, and NLP tools for intelligent document parsing and question answering.",
            "Implemented PDF text extraction, semantic search, and context-aware answer generation.",
            "Provides an interactive experience for students and researchers to query large documents instantly."
        ]
    },
    "productapi": {
        heading: "Product Backend API",
        icon: "server",
        iconType: "fas",
        projectLink: "https://github.com/25abubakar/Product-Backend-Api",
        repoLink: "https://github.com/25abubakar/Product-Backend-Api",
        projectDesc: [
            "A fully functional RESTful Web API built with <strong>C# and .NET Core</strong> for product management.",
            "Implements CRUD operations with <strong>Entity Framework Core</strong> and <strong>SQL Server</strong> as the database.",
            "Follows clean architecture principles with proper separation of concerns (Controllers, Services, Repositories).",
            "Includes input validation, error handling, and secure API design patterns."
        ]
    },
    "salesmanagement": {
        heading: "Sales Management System",
        icon: "chart-line",
        iconType: "fas",
        projectLink: "https://github.com/25abubakar/SalesManagementSystem",
        repoLink: "https://github.com/25abubakar/SalesManagementSystem",
        projectDesc: [
            "A full-stack Sales Management System built with <strong>TypeScript</strong> for managing products, orders, and sales reports.",
            "Features a responsive dashboard with real-time sales analytics and inventory tracking.",
            "Implements role-based access control and secure authentication.",
            "Designed with a clean, modern UI using Bootstrap and component-based architecture."
        ]
    },
    "shopifystore": {
        heading: "Shopify Store (E-Commerce)",
        icon: "shopping-cart",
        iconType: "fas",
        projectLink: "https://github.com/25abubakar/ShopifyStore",
        repoLink: "https://github.com/25abubakar/ShopifyStore",
        projectDesc: [
            "A full-featured e-commerce web application built with <strong>C# and ASP.NET MVC</strong>.",
            "Includes product listings, shopping cart, order management, and user authentication.",
            "Integrated with <strong>SQL Server</strong> for persistent data storage and Entity Framework for ORM.",
            "Responsive frontend built with Bootstrap for a seamless shopping experience across devices."
        ]
    },
    "schoolmanagement": {
        heading: "School Management System",
        icon: "school",
        iconType: "fas",
        projectLink: "https://github.com/25abubakar/SchoolManagementSystem",
        repoLink: "https://github.com/25abubakar/SchoolManagementSystem",
        projectDesc: [
            "A comprehensive School Management System for managing students, teachers, classes, and grades.",
            "Built with <strong>CSS / HTML / JavaScript</strong> frontend and a structured backend architecture.",
            "Features student enrollment, attendance tracking, grade management, and report generation.",
            "Clean and intuitive UI designed for ease of use by school administrators."
        ]
    },
    "campusmanagement": {
        heading: "Campus Management System",
        icon: "university",
        iconType: "fas",
        projectLink: "https://github.com/25abubakar/Campus-Management-System",
        repoLink: "https://github.com/25abubakar/Campus-Management-System",
        projectDesc: [
            "A full-stack Campus Management System built with <strong>C# and .NET</strong> for university administration.",
            "Manages student records, course registrations, faculty assignments, and academic schedules.",
            "Implements role-based access for Admin, Faculty, and Students with secure login.",
            "Uses <strong>SQL Server</strong> for robust data management and reporting."
        ]
    },
    "patientform": {
        heading: "Patient Form",
        icon: "heartbeat",
        iconType: "fas",
        projectLink: "https://github.com/25abubakar/Patient-Form",
        repoLink: "https://github.com/25abubakar/Patient-Form",
        projectDesc: [
            "A digital patient registration and data collection form built for healthcare use cases.",
            "Captures patient personal details, medical history, and appointment information.",
            "Built with clean HTML, CSS, and JavaScript with form validation and responsive design.",
            "Designed to be simple, accessible, and easy to use for medical staff and patients."
        ]
    },
    "quizapp": {
        heading: "Quiz App",
        icon: "question-circle",
        iconType: "fas",
        projectLink: "https://github.com/25abubakar/Quiz-App",
        repoLink: "https://github.com/25abubakar/Quiz-App",
        projectDesc: [
            "A simple and interactive web application designed to test users' knowledge through multiple-choice questions.",
            "Built with modern web technologies providing an engaging quiz experience with score tracking.",
            "Features dynamic question rendering, answer validation, and a results summary screen.",
            "Responsive design ensures a smooth experience on both desktop and mobile devices."
        ]
    }
};

export default PROJECT_DATA;
